import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class RandomHelper {
    public generate(): string {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }
}
